<template>
  <div class="bg-circle">
    <div class="line line-top"></div>
    <div class="company-name">{{ companyName }}</div>
    <div class="company-branch">{{ companyBranch }}</div>
    <div class="company-skillset">{{ companySkillset }}</div>
    <div class="line line-bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'CompanyLogo',
  props: {
    companyName: String,
    companyBranch: String,
    companySkillset: String
  }
}
</script>

<style scoped>
.bg-circle { 
  width: 275px;
  height: 275px;
  
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  
  border: 3px solid #949494;
  background-color: #080808;
  color: white;
}

.line {
  width: 205px;
  height: 2px;
  
  border-radius: 1px;
  -moz-border-radius: 1px;
  -webkit-border-radius: 1px;
  background-color: #DEDEDE;
}

.line-top {
  margin: 82px 0px 0px 0px;
  position: relative;
  left: 50%;
  transform: translate(-50%);
}

.line-bottom {
  margin: 0px 0px 0px 0px;
  position: relative;
  left: 50%;
  top: -22px;
  transform: translate(-50%);
}

.company-name {
  font-family: Helvetica, arial, 'sans-serif';
  font-size: 42px;
  white-space: nowrap;
  color: #7e7696;

  position: relative;
  top: -7px;
}

.company-branch {
  font-family: Helvetica, arial, 'sans-serif';
  font-size: 25px;
  white-space: nowrap;
  color: #DEDEDE;

  position: relative;
  top: -21px;
}

.company-skillset {
  font-family: Helvetica, arial, 'sans-serif';
  font-size: 14px;
  white-space: nowrap;
  color: #949494;

  position: relative;
  top: -26px;
}
</style>